import { render, staticRenderFns } from "./reserveCatalogManageList.vue?vue&type=template&id=5c230a9b&scoped=true"
import script from "./reserveCatalogManageList.vue?vue&type=script&lang=js"
export * from "./reserveCatalogManageList.vue?vue&type=script&lang=js"
import style0 from "./reserveCatalogManageList.vue?vue&type=style&index=0&id=5c230a9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c230a9b",
  null
  
)

export default component.exports